import React from 'react';
import { useLocation } from 'react-router-dom';
import SEOHelmet from './SEOHelmet';
import { findPublicRoute } from '../publicRoutes';

const RouteSEO = () => {
  const { pathname } = useLocation();
  const route = findPublicRoute(pathname.replace(/\/$/, '') || '/');

  if (!route) return null;

  return (
    <SEOHelmet
      title={route.title}
      description={route.description}
      path={route.url}
      schemaType={route.schemaType}
      breadcrumb={route.breadcrumb}
      about={route.about}
    />
  );
};

export default RouteSEO;
